import React from 'react';
import { X, Handshake, Star, RotateCcw, TrendingUp } from 'lucide-react';

interface ActionButtonsProps {
  onReject: () => void;
  onSuperLike: () => void;
  onLike: () => void;
  onRewind?: () => void;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  onReject,
  onSuperLike,
  onLike,
  onRewind
}) => {
  return (
    <div className="flex items-center justify-center gap-4 px-6 py-6 bg-white flex-shrink-0">
      {onRewind && (
        <button
          onClick={onRewind}
          className="
            w-12 h-12 rounded-full
            bg-amber-500 text-white
            hover:bg-amber-600 hover:scale-110
            active:scale-95
            focus:outline-none focus:ring-4 focus:ring-amber-200
            transition-all duration-200 ease-out
            flex items-center justify-center
          "
        >
          <RotateCcw className="w-5 h-5" />
        </button>
      )}
      
      <button
        onClick={onReject}
        className="
          w-16 h-16 rounded-full
          bg-white border-2 border-gray-200
          text-gray-500
          hover:border-red-300 hover:text-red-500 hover:scale-110
          active:scale-95
          focus:outline-none focus:ring-4 focus:ring-red-100
          transition-all duration-200 ease-out
          flex items-center justify-center
        "
      >
        <X className="w-7 h-7" />
      </button>

      <button
        onClick={onSuperLike}
        className="
          w-12 h-12 rounded-full
          bg-blue-500 text-white
          hover:bg-blue-600 hover:scale-110
          active:scale-95
          focus:outline-none focus:ring-4 focus:ring-blue-200
          transition-all duration-200 ease-out
          flex items-center justify-center
        "
      >
        <TrendingUp className="w-5 h-5" />
      </button>

      <button
        onClick={onLike}
        className="
          w-16 h-16 rounded-full
          bg-green-500 text-white
          hover:bg-green-600 hover:scale-110
          active:scale-95
          focus:outline-none focus:ring-4 focus:ring-green-200
          transition-all duration-200 ease-out
          flex items-center justify-center
        "
      >
        <Handshake className="w-7 h-7" />
      </button>
    </div>
  );
};